<div class="sk-cms-nodata">
    <span class="text">
    {{if !text || text.length == 0}}
        暂无数据!
    {{else}}
        {{text}}
    {{/if}}
    </span>
    {{if isDesign}}
    <span class="tips">
    {{if !textB || textB.length == 0}}
        请点击右上角编辑!
    {{else}}
        {{textB}}
    {{/if}}
    </span>
    {{/if}}
</div>